export default "__VITE_ASSET__D95it78$__"